import type { FaireProductEntity } from "../../entity_types/product";

export const p_mpezqay46y: FaireProductEntity = {
  token: "p_mpezqay46y",
  type: "product",
  name: "Krackle Wax Melts | Country Cabin | 4 oz Scented Wax Melts | Made in The USA | Woody Pine & Spicy Forest Fragrance",
  brandName: "Krackle Candle",
  imageUrl:
    "https://cdn.faire.com/fastly/b254bb418bde7357726e5b5773fdd0819deab478b89d9ba2873e2ca9b8f006ae.jpeg",
  priceDollars: 2.49,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/40afd180fbbafdc1d2e2ed1a93c7548e36a113970811d5aff10365353a81fcac.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
